var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 237.99999999999997 48.2465503692627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.55,0,0,0.55,-3.029715442657471,-3.7587000608444217)",
    fill: "#4f46e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,93.166C26.198,93.166,6.834,73.802,6.834,50S26.198,6.834,50,6.834S93.166,26.198,93.166,50S73.802,93.166,50,93.166z   M50,8.834C27.301,8.834,8.834,27.301,8.834,50S27.301,91.166,50,91.166S91.166,72.699,91.166,50S72.699,8.834,50,8.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.714,46.55l-0.107-0.742c18.198-2.623,28.245-13.025,31.72-17.375l0.586,0.468C73.382,33.32,63.177,43.889,44.714,46.55z  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.793,
    cy: 46.114,
    r: 2.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.514,
    cy: 28.767,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.874,80.997c-3.484-4.387-9.012-13.539-6.895-25.552l0.738,0.131c-2.066,11.723,3.338,20.666,6.743,24.954L33.874,80.997  z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.345,
    cy: 55.653,
    r: 2.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.08,
    cy: 80.649,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.553,58.284l-0.75-0.021c0.262-9.375-3.322-18.348-10.093-25.265c-7.05-7.204-16.891-11.292-27.026-11.233l-0.005-0.75  c10.321-0.04,20.376,4.11,27.567,11.458C75.16,39.537,78.82,48.704,78.553,58.284z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.128,
    cy: 58.131,
    r: 2.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.819,
    cy: 21.442,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.399,79.061c-22.622-1.116-37.959-15.928-44.77-29.418c-5.007-9.918-5.79-19.582-2.043-25.222  c2.418-3.64,6.575-5.361,12.009-4.983l-0.052,0.748c-5.164-0.361-9.073,1.249-11.333,4.65c-3.598,5.416-2.798,14.791,2.088,24.469  c6.715,13.302,21.837,27.906,44.138,29.006L55.399,79.061z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.277,
    cy: 78.637,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.574,83.267C13.12,81.553,6.04,74.011,5.536,64.052c-0.484-9.58,5.413-20.969,19.679-24.818l0.195,0.724  C11.548,43.698,5.816,54.734,6.286,64.014c0.386,7.634,5.162,16.505,17.41,18.513L23.574,83.267z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.179,
    cy: 39.64,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.426,94.555c-0.325,0-0.654-0.015-0.988-0.046c-6.336-0.589-12.075-6.442-15.354-15.658l0.707-0.252  c3.178,8.934,8.679,14.602,14.716,15.163c3.25,0.309,6.127-1.001,7.521-3.397c1.443-2.479,1.026-5.686-1.145-8.796l0.615-0.43  c2.345,3.36,2.773,6.86,1.178,9.603C78.278,93.144,75.556,94.555,72.426,94.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.068,18.924l-0.713-0.234c1.704-5.167,4.714-8.496,8.26-9.131c2.183-0.394,4.329,0.351,5.595,1.938  c1.251,1.568,1.453,3.679,0.556,5.79l-0.689-0.293c0.786-1.85,0.621-3.683-0.452-5.029c-1.094-1.371-2.963-2.01-4.877-1.667  C67.481,10.882,64.683,14.027,63.068,18.924z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.771,
    cy: 18.677,
    r: 2.82
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2876836426179512,0,0,1.2876836426179512,67.97424635170826,7.299652406599444)",
    fill: "#233142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6 l-5.82 14.06 l-2.74 0 l-5.82 -14.06 l2.96 0 l4.22 10.9 l4.24 -10.9 l2.96 0 z M18.66 20 l-2.62 0 l0 -14 l2.62 0 l0 14 z M33.56 19.82 l0 0.18 l-3.14 0 l-4.08 -4.68 l-2.54 0 l0 4.68 l-2.64 0 l0 -14.02 c2.22 0 4.44 0.02 6.66 0.02 c3.3 0.02 5.04 2.22 5.04 4.64 c0 1.92 -0.88 3.86 -3.54 4.4 z M27.82 8.46 l-4.02 0 l0 4.48 l4.02 0 c1.68 0 2.4 -1.12 2.4 -2.24 s-0.74 -2.24 -2.4 -2.24 z M38.879999999999995 20 l0 -11.6 l-4.44 0 l0 -2.4 l11.52 0 l0 2.4 l-4.44 0 l0 11.6 l-2.64 0 z M57.64 6.02 l2.62 0 l0 8.02 c0 4.14 -2.54 6.26 -6.06 6.26 c-3.36 0 -6.22 -2.04 -6.22 -6.26 l0 -8.02 l2.62 0 l0 8.02 c0 2.52 1.44 3.86 3.62 3.86 s3.42 -1.46 3.42 -3.86 l0 -8.02 z M73.96 20 l-1.18 -2.64 l-7.32 0 l-1.2 2.64 l-2.86 0 l6.28 -14 l2.88 0 l6.28 14 l-2.88 0 z M71.72 14.9 l-2.6 -5.96 l-2.6 5.96 l5.2 0 z M77.82000000000001 6 l2.64 0 l0 11.56 l7.2 0 l0 2.44 l-9.84 0 l0 -14 z M93.56000000000002 6 l2.64 0 l0 11.56 l7.2 0 l0 2.44 l-9.84 0 l0 -14 z M116.38000000000001 20 l-1.18 -2.64 l-7.32 0 l-1.2 2.64 l-2.86 0 l6.28 -14 l2.88 0 l6.28 14 l-2.88 0 z M114.14000000000001 14.9 l-2.6 -5.96 l-2.6 5.96 l5.2 0 z M122.76000000000002 13.940000000000001 l0 3.6 l4.04 0 c1.08 0 2.62 -0.36 2.62 -1.68 c0 -1.26 -1.54 -1.92 -2.62 -1.92 l-4.04 0 z M122.76000000000002 8.4 l0 3.22 l4.04 0 c1.66 0 2.2 -0.7 2.2 -1.5 c0 -0.64 -0.52 -1.72 -2.2 -1.72 l-4.04 0 z M126.80000000000003 6 c2.76 0 4.82 1.24 4.82 4.06 c0 1.08 -0.52 2.12 -1.82 2.7 c1.64 0.5 2.24 2.24 2.24 3.12 c0 3.12 -2.34 4.12 -5.24 4.12 l-6.64 0 l0 -14 l6.64 0 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ba590bce1bb0bb4fd0d2e627c80c39e.svg";
export { ForwardRef as ReactComponent };